<!--FunctionButtons.svelte-->
<script>
  import Drawer from './Drawer.svelte';
  import DrawerCoupon from './DrawerCoupon.svelte';
  import { panelState, alwaysVisible, togglePanel, setPanelState } from './GroupButtonsPanelStore.svelte';
    import HelpContent from './HelpContent.svelte';
  import HelpModal from './HelpModal.svelte';

  export let undo;
  export let undoStack;
  // export let redo;
  // export let redoStack;
  export let showResponse;
  export let updateNumber;
  export let count;
  export let response; 
  export let payload;
  export let handleSubmit;
  export let handleSubmitLive;
  export let submittedLive; 
  export let activeGame;
  export let reduceActive;
  export let gameData;
  export let matches;
  export let groups;
  export let v1;
  export let vX;
  export let v2;
  export let antalTecken;
  export let selectButton;
  export let isFormDisabled;
  export let isDeleteDisabled;
  export let utd;
  export let formatCurrencySEK;
  export let toggleShowMenu;
  export let activeTab;
  export let responseLive;
  export let insats;

    let isLoading = true;  // Add this line to create a loading state

  // export let updateData; 

  export let drawerOpen = false;

  let wigglingButton = null;

  function handleClick(buttonId) {
    wigglingButton = buttonId;
    setTimeout(() => wigglingButton = null, 500); // Reset after animation
  }

  let modalOpen = false;

  function toggleModalHelp() {
    modalOpen = !modalOpen;
  }

  function handleModalOpen() {
    console.log('Modal opened');
  }

  function handleModalClose() {
    modalOpen = false;
    console.log('Modal closed');
  }

  function setHidden() {
        togglePanel();
  }

  export function toggleDrawer() {
    drawerOpen = !drawerOpen;
    isLoading = true;  // Add this line to create a loading state
  }

  export function setActiveTab(index) {
    activeTab = index;
  }

  function toggleRevenue() {
    if ( $panelState === 'openRevenue') {
      selectButton(0);
      togglePanel('peak');
    } else {
      selectButton(0);
      togglePanel('openRevenue');
    }
  }

</script>

<div class="functionButtonsGroup">
  <button class="noBG functionButtonsLeft" on:click={undo} disabled={undoStack.length === 0}>
    <img src="/images/undo.svg" height="24pt" alt="Ångra (Ctrl/Cmd+Z)" title="Ångra (Ctrl/Cmd+Z)" />
  </button>
<!--   <button class="noBG functionButtonsLeft" on:click={redo} disabled={redoStack.length === 0}>
    <img src="/images/redo.svg" height="24pt" alt="Gör om (Ctrl/Cmd+Shift+Z)" title="Gör om (Ctrl/Cmd+Shift+Z)" />
  </button> -->
  <button class="noBG functionButtonsLeft delete" on:click={() => showResponse = true} on:click={updateNumber(count)} disabled={isDeleteDisabled}>
    <!-- <img src="/images/delete.svg" height="24pt" alt="Radera (Delete/Cmd+Backspace)" title="Radera (Delete/Cmd+Backspace)"/> -->
    Rensa
  </button>

    <button 
      class="big" 
      type="submit" 
      on:click={() => showResponse = false} 
      on:click={() => setActiveTab(0)} 
      on:click={handleSubmit(activeGame)} 
      on:click={toggleDrawer}
      on:click={toggleShowMenu(false)}
      disabled={isFormDisabled}>
      {#if reduceActive}
        Reducera
      {:else}
        Beräkna
      {/if}
  </button>
          
   <button 
    class="noBG help functionButtonsRight"
    on:click={toggleModalHelp}
   >
    <img src="/images/help.svg" height="24pt" alt="Hjälp" title="Hjälp" />
  </button>
  <button 
    class="noBG functionButtonsRight"
    on:click={() => handleClick('moneybag')}
    on:click={toggleRevenue}
  >
    <img 
      src="/images/moneybag.svg" 
      height="26pt" alt="Utdelning" 
      title="Utdelning" 
      class:wiggle={wigglingButton === 'moneybag'}
    />
    {#if utd[1] > 0 && utd[2] < 100000000}
      <br />{formatCurrencySEK(utd[1],false)}-{formatCurrencySEK(utd[2])}
    {/if}
    {#if utd[1] > 0 && utd[2] === 100000000}
      <br />&gt;{formatCurrencySEK(utd[1])}
    {/if}
    {#if utd[1] === 0 && utd[2] < 100000000}
      <br />&lt;{formatCurrencySEK(utd[2])}
    {/if}
  </button>
<!--   <button 
    class="noBG"
    on:click={setHidden}
  >{$panelState}
    <img src="/images/minmax.svg" height="16pt" alt="Reduceringsfilter" title="Reduceringsfilter" />
  </button> -->

  <Drawer bind:isOpen={drawerOpen} {toggleShowMenu}>
    <DrawerCoupon bind:submittedLive={submittedLive} bind:insats={insats} bind:isLoading={isLoading} {responseLive} {activeTab} {setActiveTab} {payload} {response} {gameData} {matches} {groups} {v1} {vX} {v2} {antalTecken} {formatCurrencySEK} {handleSubmitLive} {utd} />
  </Drawer>

<HelpModal 
  isOpen={modalOpen}
  title="Hjälp"
  on:open={handleModalOpen}
  on:close={handleModalClose}
>
<HelpContent />
  <!-- Add more content here -->
</HelpModal>

<!--           <button style="flex:1" on:click={() => updateData(activeGame)}>U</button>
          <button style="flex:1" on:click={downloadImage}>D</button>
 -->

        </div>

<style>

  .functionButtonsGroup {
/*     z-index: 30; */
    display: flex;
    background-color: var(--themeColor1);
/*     border-top: 3pt solid var(--themeColor1); */
  /*  border-width: 5px;
    border-style: double;
    border-bottom: none;
    border-radius: 20pt 20pt 0 0; */
    text-align: center;
/*     padding: 3px; */
    margin: 0 auto;
    margin-bottom: 3pt;
    width: 100%;
    max-width:863px;
    height: 40pt;
  /*   bottom: 0pt; */
  /*     background-color: rgba(255,255,255,0.1); */
/*       border: 2px solid yellow; */
  }

  button {
    cursor: pointer;
  }

  button img {
    vertical-align: text-top;
  }

  button.noBG {
/*     background-color: rgba(255,255,255,0.1); */
/*     border-radius: 20pt; */
    background: none;
    border: none;
    color: var(--themeColorText);
    margin: 0;
    filter: opacity(95%);
  }

  button.noBG:hover {
    filter: opacity(100%);
  }

  .functionButtonsLeft {
    flex: 3;
  }

  .functionButtonsRight {
    flex: 3;
  }

  .delete {
    font-size: 12pt !important;
  }

  .delete:disabled:hover {
   text-decoration: none; 
  }

  .delete:hover {
    text-decoration: underline;
  }


  button.noBG:disabled {
    filter: opacity(35%);
  }

   button.help:hover {
    cursor: help;
  }

  button.big {
    flex: 8;
    vertical-align: text-top;
    color: var(--themeColor1);
    background: var(--themeColorText);
    border-radius: 20pt;
    border: 4pt double var(--themeColor1);
    margin: 2pt;
  }

  button.big:disabled {
    filter: opacity(35%);
  }

  @keyframes wiggle {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(-15deg); }
    75% { transform: rotate(15deg); }
    100% { transform: rotate(0deg); }
  }

  .wiggle {
    animation: wiggle 0.5s ease;
  }  

  @media (max-width: 768px) {
    .functionButtonsGroup {
/*       position: sticky; */
      bottom: 0;
      padding: 0;
      height: 38pt;
    }

    .functionButtonsGroup button.noBG {
      font-size: 7pt;
    }
  }
</style>